import { render, staticRenderFns } from "./customer-highseas.vue?vue&type=template&id=c2cee11e&scoped=true&"
import script from "./customer-highseas.vue?vue&type=script&lang=js&"
export * from "./customer-highseas.vue?vue&type=script&lang=js&"
import style0 from "./customer-highseas.vue?vue&type=style&index=0&id=c2cee11e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cee11e",
  null
  
)

export default component.exports